<script setup>
import CrawlerStatus from "@/components/actions/partials/settings/CrawlerStatus.vue";
import {crawlStatusQuery} from "@/composables/crawler/useCrawler";
import useWebsite from "@/composables/useWebsite";

const {websiteId} = useWebsite();

const {data: currentStageText} = crawlStatusQuery(websiteId);
</script>

<template>
  <div
    class="tw-bg-white tw-p-8 tw-rounded-lg tw-flex tw-flex-col tw-items-center tw-gap-16 tw-justify-center tw-align-middle tw-h-[80vh]"
  >
    <svg-vue
      icon="illustrations/actions"
      class="tw-w-[600px]"
    />

    <p class="tw-text-2xl tw-font-bold">
      Your website is currently being crawled, this process can take up to 60 minutes to complete.
    </p>

    <CrawlerStatus
      :current-stage-text="currentStageText"
      class="tw-h-40"
    />
  </div>
</template>
